/*
 * @Author: yanghailong
 * @Date: 2025-01-10 09:27:00
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-10 09:27:28
 */

import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help.js"


class ChargePileElement extends GraphElement {
  static fromJSON = createFromJSON(this)
  constructor(topology, x, y, attrs) {
    super(topology, 'chargePile', x, y, {
      text: '充电桩',
      port: true,
      ...attrs
    })
  }
}

export { ChargePileElement }
